export default {"src":"/_next/static/media/gl-carousel-1-5.863ad185.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};